module.exports = __webpack_public_path__ + "img/167.95bb9dee.jpg";